import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

// modal

export default function BCtowalletmodtwo(props) {
  const navigate = useNavigate();
  return (
    <>
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="BCtwalletmod"
      >
        <Modal.Body>
          <div className="trassaction_mod_inner position-relative">
            <a
              href="javascript:void(0)"
              className="arrow-back d-flex align-items-center gap-2"
              onClick={props.onhide}
            >
              <span className="me-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 40 30"
                  fill="none"
                >
                  <g clip-path="url(#clip0_48_5634)">
                    <path
                      d="M3.23437 13.2344C2.25781 14.2109 2.25781 15.7969 3.23437 16.7734L15.7344 29.2734C16.7109 30.25 18.2969 30.25 19.2734 29.2734C20.25 28.2969 20.25 26.7109 19.2734 25.7344L11.0312 17.5L35 17.5C36.3828 17.5 37.5 16.3828 37.5 15C37.5 13.6172 36.3828 12.5 35 12.5L11.0312 12.5L19.2656 4.26562C20.2422 3.28906 20.2422 1.70312 19.2656 0.72656C18.2891 -0.250003 16.7031 -0.250003 15.7266 0.72656L3.22656 13.2266L3.23437 13.2344Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_48_5634">
                      <rect
                        width="30"
                        height="40"
                        fill="white"
                        transform="translate(0 30) rotate(-90)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              </span>

              <h4 className="m-0">{props.title}</h4>
            </a>

             <div className="order_details_list">

                 <div className="order_addres d-flex align-items-center justify-content-between my-3">
                     <p className="m-0 text-truncate">x6731bdb8a13d1e93f2c517cae5a648249db3ab57dssvs</p>
                     <div className="icon_addrees">
                        <img src="/images/XRP.png" alt="" className="img-fluid"/>
                     </div>
                 </div>
                 
                  
                  <div className="details_modal_list mt-3">
                    <h4 className="pb-2">ORDER DETAILS</h4>
                    <ul className="m-0 p-0 order_detail_list">
                        <li>
                           <p>0.05686366 ETH @ 168567.25 INR</p>
                           <p><strong>9585.35 INR</strong></p>
                        </li>

                        <li>
                           <p>Network/Exchange fee</p>
                           <p><strong>215.65 INR</strong></p>
                        </li>

                        <li>
                           <p>Transak fee</p>
                           <p><strong>199 INR</strong></p>
                        </li>

                        <li>
                           <p>Total</p>
                           <p><strong>10000 INR</strong></p>
                        </li>
                    </ul>
                  </div>

                <Button className="btn_sign_in w-100 btn_theme mt-4" onClick={props.toggleentermod}>Buy Now</Button>

             </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
